export default __webpack_public_path__ + "static/media/Roboto-Thin.d0c8142f.ttf";